/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {simDialogAnimations as ɵb} from './dialog-animations';
export {SimDialogComponent as ɵa} from './dialog.component';